// Drawing Guess easel geometry (table-local, floor origin, metres, +Y up).
// The drawing faces +Z: players stand in front of it (z > 0). Shared by the
// furniture, the live drawing surface and the scoreboards so they line up.

import { ASPECT } from './strokes';

/** Outer frame width (the placed object is ~2.5 m wide). */
export const FRAME_W = 2.5;
/** Drawing surface (3:2, the same aspect as every canvas). */
export const BOARD_W = 2.3;
export const BOARD_H = BOARD_W / ASPECT;
/** Bottom edge of the drawing surface. */
export const BOARD_BOTTOM = 0.86;
export const BOARD_CY = BOARD_BOTTOM + BOARD_H / 2;
export const BOARD_TOP = BOARD_BOTTOM + BOARD_H;
/** Front face of the board; the live drawing sits a hair in front of it. */
export const BOARD_Z = 0.04;
export const FRAME_BORDER = (FRAME_W - BOARD_W) / 2;
